import './App.css';
import {Dashboard} from './components/dashboard/Dashboard';
import { Footer } from './components/footer/Footer';
import { Header } from './components/header/Header';

function App() {
  return (
  <>
   <Header/>
    <Dashboard/>
   <Footer/>
  </>
  )
}

export default App;
